import styled from 'styled-components'

export const LayoutContainer = styled.div`
    /* margin-left: 50px; */
    padding-top: 50px;
`
